import React from 'react';
import { useSelector } from 'react-redux';

import { REGEX_EMBED, REGEX_WISTIA, REGEX_YOUTUBE, TRAINING_PRODUCT_TYPES } from '../../../constants';
import { getFileData } from '../../../utils';
import { Media } from '../Media';

const TrainingIntro = ({ introBook, title, subTitle, description = '', shortDescription, descriptionTitle, author, product, image, fov }) => {
     const message = useSelector((state) => state.general.message);

     const isVideo = () => {
          const fileData = getFileData(image);

          const isEmbed = REGEX_EMBED.test(image);
          const isVideoYoutube = REGEX_YOUTUBE.test(image);
          const isVideoWistia = REGEX_WISTIA.test(image);

          if (isEmbed || isVideoYoutube || isVideoWistia || fileData.extension === 'mp4') {
               return true;
          }
          return false;
     };

     return (
          <div
               className={`training-intro${
                    product?.productType?.trainingProductType === TRAINING_PRODUCT_TYPES.PHYSICAL_PRODUCT ? ' intro-no-book' : ''
               }`}
          >
               {product?.productType?.trainingProductType === TRAINING_PRODUCT_TYPES.PHYSICAL_PRODUCT ? (
                    <div className="header-training-physical">
                         <div className="training-intro-book">
                              {(title || subTitle || author) && (
                                   <div className="training-intro-title">
                                        {title && <h1>{title}</h1>}
                                        {subTitle && <p dangerouslySetInnerHTML={{ __html: subTitle }}></p>}
                                        {author && <span>{author}</span>}
                                   </div>
                              )}

                              {shortDescription && (
                                   <div className="training-intro-short-description">
                                        <p className="purchase" dangerouslySetInnerHTML={{ __html: shortDescription }}></p>
                                   </div>
                              )}

                              {(descriptionTitle || (description && introBook)) && (
                                   <div className="training-intro-description">
                                        {descriptionTitle && <h3 dangerouslySetInnerHTML={{ __html: descriptionTitle }}></h3>}
                                        <div className="description-content">
                                             {description && (
                                                  <div
                                                       className="description-main editor-description"
                                                       dangerouslySetInnerHTML={{ __html: description }}
                                                  />
                                             )}
                                        </div>
                                   </div>
                              )}
                         </div>
                         <div className="book-wrapper">
                              {image && !isVideo() && (
                                   <div className="image-book-org">
                                        <img src={image} alt="" className="book"></img>
                                   </div>
                              )}

                              {image && isVideo() && <Media src={image} />}
                              {/* {product?.productType?.trainingProductType === TRAINING_PRODUCT_TYPES.PHYSICAL_PRODUCT && image && (
                                   <img src={image} alt="" className="book"></img>
                              )} */}
                         </div>
                    </div>
               ) : (
                    <div className={`header-course-personal ${!isVideo() ? 'd-flex' : ''}`}>
                         <div className="content-course-personal">
                              {(title || subTitle || author) && (
                                   <div className="training-intro-title">
                                        {title && <h1>{title}</h1>}
                                        {subTitle && <p dangerouslySetInnerHTML={{ __html: subTitle }}></p>}
                                        {author && <span>{author}</span>}
                                        {message && fov ? <label dangerouslySetInnerHTML={{ __html: message }}></label> : ''}
                                   </div>
                              )}
                              {shortDescription && (
                                   <div className="training-intro-short-description">
                                        <p className="purchase" dangerouslySetInnerHTML={{ __html: shortDescription }}></p>
                                   </div>
                              )}
                              {(descriptionTitle || description) && (
                                   <div className="training-intro-description">
                                        {descriptionTitle && <h3 dangerouslySetInnerHTML={{ __html: descriptionTitle }} />}
                                        {description && <p className="text-editor" dangerouslySetInnerHTML={{ __html: description }}></p>}
                                   </div>
                              )}
                         </div>

                         {image && !isVideo() && (
                              <div className="image-course-personal">
                                   <img src={image} alt=""></img>
                              </div>
                         )}

                         {image && isVideo() && <Media src={image} />}
                    </div>
               )}
          </div>
     );
};

export default TrainingIntro;
